// kidos-klaviyo-popup-fix.js
// Popup Klaviyo (ID de formulario TsetMx):
// - Aplica estilos al texto del checkbox de WhatsApp
// - Marca el checkbox por defecto simulando un click real
// - Obliga a tenerlo marcado para obtener el 10%
// - Oculta el bloque legal duplicado original de Klaviyo
// - Incluye logs de debug [kidos-klaviyo-popup-fix test v1]

(function () {
  // 🔹 ID del formulario de Klaviyo (lo ves en data-testid="klaviyo-form-XXX")
  const FORM_ID = 'TsetMx';

  // 🔹 Selector del formulario específico del popup
  const FORM_SELECTOR = `form[data-testid="klaviyo-form-${FORM_ID}"]`;

  // 🔹 Selector del checkbox de consentimiento promocional (WhatsApp)
  //     Klaviyo genera IDs dinámicos que empiezan con "opt_in_promotional_sms"
  const CHECKBOX_SELECTOR =
    'input[id^="opt_in_promotional_sms"][type="checkbox"]';

  // 🔹 Selector del texto que acompaña al checkbox (el <div> dentro del <label>)
  const CHECKBOX_TEXT_SELECTOR =
    '[id^="opt_in_promotional_sms"] + label > div';

  // Log para comprobar que el script se cargó en la página
  console.log('[kidos-klaviyo-popup-fix test v1] script cargado');

  /**
   * Busca el botón principal del popup (el de "OBTENER 10%").
   *
   * Klaviyo usa <button type="button"> tanto para el CTA como para el "No, Gracias",
   * así que:
   *  - Se buscan todos los botones type="button"
   *  - Se intenta elegir el que contiene el texto "OBTENER"
   *  - Si no se encuentra, se devuelve el primero como fallback
   */
  function findSubmitButton(form) {
    const buttons = Array.from(form.querySelectorAll('button[type="button"]'));
    if (!buttons.length) return null;

    const byText = buttons.find((b) =>
      (b.textContent || '').toUpperCase().includes('OBTENER')
    );
    return byText || buttons[0];
  }

  /**
   * Muestra el mensaje de error cuando el checkbox NO está marcado
   * pero el usuario intenta obtener el 10%.
   *
   * - Crea un <div> de error solo si no existe uno ya.
   * - Lo inserta dentro del <fieldset> del checkbox (o al final del form si no hay fieldset).
   */
  function showError(form) {
    let error = form.querySelector('[data-kidos-whatsapp-error]');
    if (!error) {
      error = document.createElement('div');
      error.dataset.kidosWhatsappError = '1';
      error.textContent =
        '👆 Debes marcar la casilla para obtener tu descuento.';
      error.style.color = '#dc2626';
      error.style.fontSize = '12px';
      error.style.marginTop = '4px';
      error.style.lineHeight = '1.4';

      const fieldset = form.querySelector('fieldset');
      if (fieldset) {
        fieldset.appendChild(error);
      } else {
        form.appendChild(error);
      }
    }
  }

  /**
   * Elimina el mensaje de error del checkbox (si existe).
   * Se usa cuando el usuario marca el checkbox correctamente
   * y vuelve a intentar enviar el formulario.
   */
  function clearError(form) {
    const error = form.querySelector('[data-kidos-whatsapp-error]');
    if (error) {
      error.remove();
    }
  }

  /**
   * Oculta el bloque legal original de Klaviyo que queda duplicado,
   * porque tú ya agregaste un texto legal personalizado en el popup.
   *
   * Lógica:
   *  - Busca un <div> cuyo contenido comience con
   *    "Al enviar este formulario, das tu consentimiento"
   *  - Sube hasta el contenedor con data-testid="form-row"
   *  - Oculta toda esa fila con display: none
   */
  // 🔹 Ocultar el bloque legal duplicado
  function hideDuplicatedLegalRow(form) {
    const legalDiv = Array.from(form.querySelectorAll('div')).find((div) => {
      const text = (div.textContent || '').trim();
      return text.startsWith(
        'Al enviar este formulario, das tu consentimiento'
      );
    });

    if (!legalDiv) return;

    const row = legalDiv.closest('div[data-testid="form-row"]');
    if (row) {
      console.log(
        '[kidos-klaviyo-popup-fix test v1] ocultando bloque legal duplicado'
      );
      row.style.display = 'none';
    }
  }

  /**
   * Marca el checkbox de WhatsApp simulando un click de usuario.
   *
   * Importante:
   *  - No seteamos checkbox.checked = true directamente,
   *    sino que usamos checkbox.click() para disparar los listeners internos de Klaviyo.
   *  - Usamos un pequeño setTimeout para dar tiempo a que Klaviyo
   *    conecte sus handlers al checkbox.
   */
  // 🔹 Marcar el checkbox simulando un click de usuario
  function autoSelectCheckbox(checkbox) {
    if (!checkbox) return;

    // Evita ejecutar la lógica dos veces sobre el mismo checkbox
    if (checkbox.dataset.kidosAutoSelected === '1') return;

    checkbox.dataset.kidosAutoSelected = '1';

    console.log(
      '[kidos-klaviyo-popup-fix test v1] autoSelectCheckbox: antes de timeout, checked =',
      checkbox.checked
    );

    // Esperamos un poco para asegurarnos de que Klaviyo ya conectó sus listeners
    setTimeout(function () {
      console.log(
        '[kidos-klaviyo-popup-fix test v1] autoSelectCheckbox: dentro de timeout, antes de click, checked =',
        checkbox.checked
      );

      // Si el usuario ya lo marcó/desmarcó antes, respetamos su decisión
      if (!checkbox.checked) {
        console.log(
          '[kidos-klaviyo-popup-fix test v1] autoSelectCheckbox: haciendo checkbox.click()'
        );
        checkbox.click(); // esto dispara sus handlers como si fuera un click real
      } else {
        console.log(
          '[kidos-klaviyo-popup-fix test v1] autoSelectCheckbox: ya estaba marcado, no hacemos click'
        );
      }

      console.log(
        '[kidos-klaviyo-popup-fix test v1] autoSelectCheckbox: después de posible click, checked =',
        checkbox.checked
      );
    }, 100);
  }

  /**
   * Inicializa toda la lógica asociada al formulario de Klaviyo:
   *
   * - Auto-marcado del checkbox (simulando interacción real).
   * - Aplicar estilos personalizados al texto del checkbox.
   * - Añadir validación para bloquear el submit si no está marcado.
   * - Ocultar el bloque legal duplicado.
   */
  function initForm(form) {
    if (!form) return false;

    // Evitar re-inicializar si ya se ejecutó antes sobre el mismo form
    if (form.dataset.kidosInitialized === '1') {
      return true;
    }
    form.dataset.kidosInitialized = '1';

    console.log('[kidos-klaviyo-popup-fix test v1] initForm llamado');

    // 1) Checkbox: marcar por defecto simulando click
    const checkbox = form.querySelector(CHECKBOX_SELECTOR);
    if (checkbox) {
      console.log(
        '[kidos-klaviyo-popup-fix test v1] checkbox encontrado, estado inicial checked =',
        checkbox.checked
      );
      //Comentado (premarcado deshabilitado por protección, calidad, etc.)
      //autoSelectCheckbox(checkbox);
    } else {
      console.warn(
        '[kidos-klaviyo-popup-fix test v1] NO se encontró el checkbox de WhatsApp'
      );
    }

    // 2) Estilos del texto del checkbox (tipografía, tamaño, color, etc.)
    const textDiv = form.querySelector(CHECKBOX_TEXT_SELECTOR);
    if (textDiv) {
      // Marca solo para debug, por si quieres identificarlo en el DOM
      textDiv.dataset.kidosFixed = '1';

      textDiv.style.fontFamily = 'var(--font-body-family)';
      textDiv.style.fontSize = '12px';
      textDiv.style.letterSpacing = '0';
      textDiv.style.lineHeight = '1.4';
      textDiv.style.color = 'var(--color-foreground)';

      console.log(
        '[kidos-klaviyo-popup-fix test v1] estilos aplicados al texto del checkbox'
      );
    } else {
      console.warn(
        '[kidos-klaviyo-popup-fix test v1] NO se encontró el div de texto del checkbox'
      );
    }

    // 3) Validación obligatoria: sin check no hay 10%
    //    Aquí enganchamos el click del botón "OBTENER 10%" para:
    //    - Bloquear el envío si el checkbox NO está marcado.
    //    - Mostrar mensaje de error en ese caso.
    const submitButton = findSubmitButton(form);
    if (submitButton && checkbox) {
      console.log(
        '[kidos-klaviyo-popup-fix test v1] submitButton encontrado, agregando listener de validación'
      );

      submitButton.addEventListener(
        'click',
        function (event) {
          if (!checkbox.checked) {
            console.log(
              '[kidos-klaviyo-popup-fix test v1] submit bloqueado: checkbox NO está marcado'
            );
            // Evita que se envíe el form o que Klaviyo siga su flujo normal
            event.preventDefault();
            if (typeof event.stopImmediatePropagation === 'function') {
              event.stopImmediatePropagation();
            } else {
              event.stopPropagation();
            }
            showError(form);
          } else {
            console.log(
              '[kidos-klaviyo-popup-fix test v1] submit permitido: checkbox marcado'
            );
            clearError(form);
          }
        },
        true // useCapture = true: interceptamos el click lo antes posible
      );
    } else {
      console.warn(
        '[kidos-klaviyo-popup-fix test v1] NO se pudo agregar validación: faltan botón o checkbox'
      );
    }

    // 4) Ocultar el bloque legal duplicado original de Klaviyo (se comenta)
    //hideDuplicatedLegalRow(form);

    return true;
  }

  /**
   * Intenta inicializar el formulario una sola vez.
   *
   * - Si el form aún no está en el DOM, devuelve false.
   * - Si ya está, llama a initForm(form).
   */
  function tryInitOnce() {
    const form = document.querySelector(FORM_SELECTOR);
    if (!form) {
      console.log(
        '[kidos-klaviyo-popup-fix test v1] tryInitOnce: no se encontró el form aún'
      );
      return false;
    }

    console.log(
      '[kidos-klaviyo-popup-fix test v1] tryInitOnce: form encontrado, iniciando'
    );
    return initForm(form);
  }

  /**
   * Punto de entrada:
   * - Esperamos a DOMContentLoaded.
   * - Intentamos inicializar inmediatamente.
   * - Si el form todavía no existe (porque Klaviyo lo inyecta después),
   *   usamos un MutationObserver para detectar cuando aparezca en el DOM.
   */
  document.addEventListener('DOMContentLoaded', function () {
    console.log(
      '[kidos-klaviyo-popup-fix test v1] DOMContentLoaded disparado, intentando init inmediato'
    );

    // Si el form ya está disponible, se inicializa y no necesitamos observer
    if (tryInitOnce()) return;

    // Si aún no está, observamos cambios en el body hasta que aparezca el form
    const observer = new MutationObserver(function () {
      if (tryInitOnce()) {
        console.log(
          '[kidos-klaviyo-popup-fix test v1] form detectado por MutationObserver, desconectando observer'
        );
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    console.log(
      '[kidos-klaviyo-popup-fix test v1] MutationObserver configurado'
    );
  });
})();
